import { createBrowserRouter } from "react-router-dom";
import { About, Blog, ContactUs, Landing, NotFound, Projects, Selector, Dashboard, ProjectDetails, ChannelPartner, GalleryGrid, GalleryDetails, Careers, NRI } from '../Pages/Exports';
import Layout from '../Layout/Layout';
import OurServices from "../Pages/OurServices";
import ServiceDetails from "../Pages/OurServices/ServicesDetails";
import Calculator from "../Pages/Projects/Calculator";
import JobDetailsPage from "../Pages/Careers/JobDetailsPage";
import ApplicationPage from "../Pages/Careers/CareerApplicationPage.tsx/ApplicationPage";
import LinkedinBlogDetails from "../Pages/Blog/SingleBlog/LinkedinBlogDetails";
import BlogDetails from "../Pages/Blog/SingleBlog/BlogDetails";
import TribujaLandingPage from "../Pages/TribujaLandingpage";



const router = createBrowserRouter([

    {
      path: '/',
      element: <Landing />,
      errorElement: <NotFound />, 
    },
    {
      // path : "/selector",
      // element : <Selector />,
    },
    {
      element: <Layout />,
      children: [
        {
          path: "/home",
          element: <Dashboard />,
        },
        {
          path: "/about",
          element: <About />,
        },
        {
          path: "/ourservices",
          element: <OurServices/>,
        },
        {
          path : "/ourservices/:id/:slug",
          element : <ServiceDetails />,
        },
        {
          //projects
          path: "/projects",
          element: <Projects />,
        },

        //projects/:id
        {
          path : "/projects/:id",
          element : <ProjectDetails />,
        },
        {
          path : "/channelpartner",
          element : <ChannelPartner />,
        },
        {
          path : "/gallery",
          element : <GalleryGrid />,
        },
        // {
        //   path: '/careers',
        //   element: <Careers />,
        // },
        // {
        //   path: '/careers/:id',
        //   element: <JobDetailsPage />
        // },
        // {
        //   path: '/careers/apply/:id',
        //   element: <ApplicationPage />
        // },
        {
          path : "/gallery/:id",
          element : <GalleryDetails />,
        },

        {
          path : "/blog",
          element : <Blog />,
        },
        {
          path:"blog/:slug",
          element:<BlogDetails/>
        },
        {
          path : "/contact",
          element : <ContactUs />,
        },
        {
          path : "/projects/:id/calculator",
          element : <Calculator />,
        },
        {
          path : "/nri",
          element : <NRI />,
        },
        {
          path: "/blogs/:slug",
          element: <LinkedinBlogDetails/>,
        },
        

        ],
    },
    {
      path : "/admin",
      element : <Dashboard />,
    },
  {
    path: "*",
    element: <NotFound />,
  },
  {
          path: "/tribhuja",
          element: <TribujaLandingPage />,
        },
]);




export default router;
